import { useEffect } from 'react';

// Setzt Titel + Meta-Description pro Seite. SPA ohne Server-Rendering hat sonst nur den
// einen statischen Titel aus public/index.html auf jeder Route — schlecht fürs SEO
// (jede Seite braucht laut Checkliste einen eigenen, eindeutigen Titel).
export default function usePageMeta(title, description) {
    useEffect(() => {
        const prevTitle = document.title;
        if (title) document.title = title;

        let descTag = null;
        let prevDescription = null;
        if (description) {
            descTag = document.querySelector('meta[name="description"]');
            if (descTag) {
                prevDescription = descTag.getAttribute('content');
                descTag.setAttribute('content', description);
            }
        }

        return () => {
            document.title = prevTitle;
            if (descTag && prevDescription !== null) descTag.setAttribute('content', prevDescription);
        };
    }, [title, description]);
}
